import { render } from 'preact';
import { App } from './app';
import { Book, Chapter } from './types';
import { Router, Route } from 'preact-router';
import { ThemeProvider } from './context/theme-context';

function renderApp() {
  const container = document.getElementById('reader');

  console.log('container', container);

  if (container) {
    const bookId = container.getAttribute('x-book-id');
    const chapterId = Number(container.getAttribute('x-chapter-id') || 0);
    const userId = container.getAttribute('x-user-id');
    const bookTitle = container.getAttribute('x-book-title');
    const bookPermalink = container.getAttribute('x-book-permalink');
    const chapterContent = container.querySelector(
      '.chapterContent .markdown',
    )?.innerHTML;
    const authorNote = container.querySelector(
      '.author_note .markdown',
    )?.innerHTML;

    const chapters: Chapter[] = Array.from(
      container.querySelectorAll('.chapter'),
    ).map((chapter) => ({
      id: Number(chapter.getAttribute('x-chapter-id')) || 0,
      permalink: chapter.getAttribute('x-chapter-permalink') || undefined,
      title: chapter.textContent || undefined,
      hydrated: false,
    }));

    // Find the current chapter in the chapters array and hydrate it
    const currentChapter = chapters.find((c) => c.id === chapterId);
    if (currentChapter) {
      currentChapter.hydrated = true;
      currentChapter.renderedContent = chapterContent || '';
      currentChapter.renderedAuthorNote = authorNote || '';
    }

    if (!bookId || !chapterId) {
      console.error('Missing required attributes', { bookId, chapterId });
    }

    const book: Book = {
      id: Number(bookId || 0),
      title: bookTitle || '',
      permalink: bookPermalink || '',
    };

    container.innerHTML = '';

    render(
      <ThemeProvider>
        <Router>
          <Route
            path="f/:fictionPermalink/c/:chapterPermalink"
            component={({
              chapterPermalink,
            }: {
              chapterPermalink: string;
              bookPermalink: string;
            }) => (
              <App
                book={book}
                userId={userId ? +userId : undefined}
                chapterPermalink={chapterPermalink}
                chapters={chapters}
              />
            )}
          />
        </Router>
      </ThemeProvider>,
      container,
    );
  }
}

renderApp();
